module.exports = __webpack_public_path__ + "img/firstfeature.2f46c06a.svg";